import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function useNavigateOnAuth() {
  const navigate = useNavigate();

  const user = useSelector((store) => store.auth);

  useEffect(() => {
    if (!user) return;
    return navigate("/stock");
  }, [user, navigate]);

  return user;
}

export default useNavigateOnAuth;
